var lx = lx || {};
lx.plugin = lx.plugin || {};

/* ex plugin_hide function*/
lx.plugin.hide = function () {
    var vObj;
    var vRet = 500;
    var isOpen = false;
    //"R"
    vObj = $("#side_list");
    if ($(vObj).css("display") == "block") {
        $(vObj).animate({
            width: "toggle"
        }, {
                duration: 500,
                specialEasing: {
                    width: "easeInQuad"
                }
            });
        isOpen = true;
    }
    //"B"
    vObj = $("#bottom_list");
    if ($(vObj).css("display") == "block") {
        $(vObj).animate({
            height: "toggle"
        }, {
                duration: 500,
                specialEasing: {
                    height: "easeInQuad"
                }
            });
        isOpen = true;
        $(".profile_mid_box_active").removeClass("profile_mid_box_active");
    }
    //"BI"
    vObj = $("#bottom_list_if");
    if ($(vObj).css("display") == "block") {
        $(vObj).animate({
            height: "toggle"
        }, {
                duration: 500,
                specialEasing: {
                    height: "easeInQuad"
                }
            });
        isOpen = true;
    }
    //"WbR"
    vObj = $("#uiWbSideList");
    if ($(vObj).css("display") == "block") {
        $(vObj).animate({
            width: "toggle"
        }, {
                duration: 500,
                specialEasing: {
                    height: "easeInQuad"
                }
            });
        isOpen = true;
    }
    if (isOpen) vRet = vRet + 500;
    var $vObj = $(".ui-lx-meni-container");
    var vTop = $vObj.offset().top;
    $(".lxProfilePlug").show();
    $(".notify-IR").show();
    lxProfileFeedFetch = true;
    return vRet;
};

/* ex plugin_show function */
lx.plugin.show = function (pDest, pContent, pNoScroll) {
    var $vObj;
    if (pDest == "R") {
        $vObj = $("#side_list");
        $vObj.html(pContent);
        $vObj.animate({
            width: "toggle"
        }, {
                duration: 1250,
                specialEasing: {
                    width: "easeOutQuad"
                }
            });
    } else if (pDest == "B") {
        $vObj = $("#bottom_list");
        $vObj.html(pContent).show();
    } else if (pDest == "BI") { // bottome iFrame
        $vObj = $("#bottom_list");
        $vObj.html("<iframe id='iframe_o' src='" + pContent + "' scrolltop='0' scrollleft='0' scrolling='auto' frameborder='0' marginheight='0' marginwidth='0' style='width:100%; height:600px;'></iframe>").show(); 
    } else if (pDest == "WbR") { // Workboard
        $vObj = $("#uiWbSideList");
        $vObj.html(pContent);
        $vObj.animate({
            width: "toggle"
        }, {
                duration: 1250,
                specialEasing: {
                    width: "easeOutQuad"
                }
            });
    }
    var vTop = $vObj.offset().top;
    if (!pNoScroll) $("html,body").animate({
        scrollTop: (vTop - 140)
    }, 1250);
};

plugin_hide = lx.plugin.hide;
plugin_show = lx.plugin.show;